import { Action, PlainObject, State } from "@zyzgroup/core-common";

function reduce(state: State, payload: PlainObject): State {
  state.id = payload.id ? String(payload.id) : ""; // payload.id 数据库中为 number
  // 名称
  state.name = payload.name || "";
  // 简称
  state.title = payload.apptitle || "";
  // 「车位缴费页」 是否支持「填写通用非税票据信息」
  state.nontax = typeof payload.nontax == "boolean" ? payload.nontax : false;
  // 小程序内预定义样式名称
  state.miniClassName = payload.minicss?.classname || "";
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_GROUP":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
